/* =============================================
   STICKS & STONES — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ── HERO SLIDESHOW ──────────────────────────
  const heroWrap = document.getElementById('heroSlides');
  if (heroWrap) {
    const slides = heroWrap.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.hero-dots .dot');
    const prevBtn = document.getElementById('heroPrev');
    const nextBtn = document.getElementById('heroNext');
    let current = 0, timer;
    const speed = parseInt(heroWrap.closest('.hero-section')?.dataset.speed || 6000);

    function goTo(i) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), speed);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); startTimer(); });
    dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.i); startTimer(); }));
    if (slides.length > 1) startTimer();
  }

  // ── HEADER SCROLL ───────────────────────────
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── MOBILE NAV ──────────────────────────────
  const overlay = document.getElementById('overlay');
  const mobNav = document.getElementById('mob-nav');
  const burgerBtn = document.getElementById('burgerBtn');
  const mobClose = document.getElementById('mobClose');

  function openMobNav() {
    mobNav?.classList.add('open');
    overlay?.classList.add('on');
    burgerBtn?.setAttribute('aria-expanded', 'true');
    mobNav?.setAttribute('aria-hidden', 'false');
  }

  function closeMobNav() {
    mobNav?.classList.remove('open');
    overlay?.classList.remove('on');
    burgerBtn?.setAttribute('aria-expanded', 'false');
    mobNav?.setAttribute('aria-hidden', 'true');
  }

  burgerBtn?.addEventListener('click', openMobNav);
  mobClose?.addEventListener('click', closeMobNav);

  // ── CART DRAWER ─────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.getElementById('cartToggle');
  const cartClose = document.getElementById('cartClose');

  function openCart() {
    cartDrawer?.classList.add('open');
    overlay?.classList.add('on');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    cartToggle?.setAttribute('aria-expanded', 'true');
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    overlay?.classList.remove('on');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartToggle?.setAttribute('aria-expanded', 'false');
  }

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);

  // Overlay closes nav + cart
  overlay?.addEventListener('click', () => { closeMobNav(); closeCart(); });



  // ── MOBILE SUBMENU ──────────────────────────
  window.toggleMobSub = function (el) {
    const sub = el.nextElementSibling;
    const expanded = el.getAttribute('aria-expanded') === 'true';
    el.setAttribute('aria-expanded', !expanded);
    sub?.classList.toggle('open');
  };

  // ── PRODUCT TABS ────────────────────────────
  document.querySelectorAll('.tab-row').forEach(row => {
    const trigger = row.querySelector('.tab-trigger');
    trigger?.addEventListener('click', () => {
      row.classList.toggle('open');
    });
  });

  // ── GALLERY THUMBNAILS ──────────────────────
  const galleryMain = document.querySelector('.prod-gallery__main img');
  document.querySelectorAll('.prod-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.prod-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (galleryMain) galleryMain.src = thumb.querySelector('img')?.src || galleryMain.src;
    });
  });

  // ── VARIANT SELECTION ───────────────────────
  document.querySelectorAll('.opt-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.prod-opt__vals');
      group?.querySelectorAll('.opt-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── STICKY ATC ──────────────────────────────
  const stickyAtc = document.getElementById('sticky-atc');
  if (stickyAtc) {
    const atcTrigger = document.querySelector('.prod-atc');
    if (atcTrigger) {
      const obs = new IntersectionObserver(entries => {
        stickyAtc.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(atcTrigger);
    }
  }

  // ── BEFORE/AFTER SLIDER ─────────────────────
  const baWrap = document.getElementById('baWrap');
  const baBefore = document.getElementById('baBefore');
  const baHandle = document.getElementById('baHandle');
  if (baWrap && baBefore && baHandle) {
    let active = false;
    const move = (x) => {
      const rect = baWrap.getBoundingClientRect();
      const pct = Math.min(100, Math.max(0, (x - rect.left) / rect.width * 100));
      baBefore.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      baHandle.style.left = pct + '%';
    };
    baWrap.addEventListener('mousedown', e => { active = true; move(e.clientX); });
    baWrap.addEventListener('touchstart', e => { active = true; move(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mouseup', () => active = false);
    window.addEventListener('touchend', () => active = false);
    window.addEventListener('mousemove', e => { if (active) move(e.clientX); });
    window.addEventListener('touchmove', e => { if (active) move(e.touches[0].clientX); }, { passive: true });
  }

  // ── COUNTDOWN TIMER ─────────────────────────
  const countdownEl = document.getElementById('ann-countdown');
  if (countdownEl) {
    const endDate = new Date(countdownEl.dataset.end || new Date().getTime() + 86400000);
    const tick = () => {
      const diff = endDate - new Date();
      if (diff <= 0) { countdownEl.textContent = 'Sale Ended'; return; }
      const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      countdownEl.textContent = `Ends in: ${h}:${m}:${s}`;
    };
    tick();
    setInterval(tick, 1000);
  }

  // ── SCROLL ANIMATIONS ───────────────────────
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  // ── CART AJAX ───────────────────────────────
  async function updateCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = document.getElementById('cart-count');
      if (count) {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
      const total = document.getElementById('cart-total');
      if (total) total.textContent = formatMoney(cart.total_price);
      const itemCount = document.getElementById('cart-item-count');
      if (itemCount) itemCount.textContent = cart.item_count;
    } catch (e) { console.warn('Cart update failed', e); }
  }

  window.quickAdd = async function (productId) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      });
      await updateCart();
      openCart();
    } catch (e) { console.warn('Quick add failed', e); }
  };

  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const valEl = btn.parentElement.querySelector('.qty-val');
      const current = parseInt(valEl?.textContent || 1);
      const qty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        await updateCart();
        if (qty === 0) btn.closest('.cart-item')?.remove();
        else if (valEl) valEl.textContent = qty;
      } catch (e) { console.warn('Qty update failed', e); }
    });
  });

  document.querySelectorAll('.cart-item__rm').forEach(rm => {
    rm.addEventListener('click', async () => {
      const key = rm.dataset.key;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        rm.closest('.cart-item')?.remove();
        await updateCart();
      } catch (e) { console.warn('Remove failed', e); }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
});

/* ============================================
   WISHLIST (localStorage-based)
   ============================================ */
(function () {
  var KEY = 'sns_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveList(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); }

  function showToast(msg, type) {
    var t = document.querySelector('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = 'toast toast--' + (type || 'success');
    setTimeout(function () { t.classList.add('show'); }, 10);
    setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  function refreshButtons() {
    var list = getList();
    document.querySelectorAll('.prod-card__wish, .prod-info__wish').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (id && list.indexOf(id) > -1) btn.classList.add('is-saved');
      else btn.classList.remove('is-saved');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.prod-card__wish, .prod-info__wish');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var list = getList();
    var idx = list.indexOf(id);
    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('is-saved');
      showToast('Removed from wishlist');
    } else {
      list.push(id);
      btn.classList.add('is-saved');
      showToast('✓ Added to wishlist');
    }
    saveList(list);
  });

  document.addEventListener('DOMContentLoaded', refreshButtons);
})();

/* ============================================
   IMAGE ZOOM (product page)
   ============================================ */
(function () {
  var modal = null;
  function openZoom(src) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'image-zoom';
      modal.innerHTML = '<button class="image-zoom__close" aria-label="Close zoom"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg></button><img src="" alt="">';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('.image-zoom__close')) closeZoom();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) closeZoom();
      });
    }
    modal.querySelector('img').src = src;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (modal) modal.classList.remove('active');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest('.prod-gallery__main img, .prod-gallery__stack-img img');
    if (img) {
      var src = img.getAttribute('data-zoom-src') || img.src;
      openZoom(src);
    }
  });
})();

/* ============================================
   PRODUCT GALLERY THUMB CLICK (mobile)
   ============================================ */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.prod-thumb');
  if (!thumb) return;
  var src = thumb.getAttribute('data-src');
  if (!src) return;
  var main = document.getElementById('prod-main-img');
  if (main) main.src = src;
  document.querySelectorAll('.prod-thumb').forEach(function (t) { t.classList.remove('active'); });
  thumb.classList.add('active');
});

/* ============================================
   SEARCH DRAWER TOGGLE
   ============================================ */
(function () {
  var btn = document.getElementById('search-toggle');
  var drawer = document.getElementById('search-drawer');
  var close = document.getElementById('search-close');
  var input = document.getElementById('search-input');
  if (!btn || !drawer) return;

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 200);
  }
  function close_() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', open);
  if (close) close.addEventListener('click', close_);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close_();
  });
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer || e.target.classList.contains('search-drawer__inner')) close_();
  });
})();

/* ============================================
   PREDICTIVE SEARCH
   ============================================ */
(function () {
  var input = document.getElementById('search-input');
  var ps = document.getElementById('predictive-search');
  if (!input || !ps) return;

  var loading = document.getElementById('ps-loading');
  var results = document.getElementById('ps-results');
  var empty = document.getElementById('ps-empty');
  var queryEl = document.getElementById('ps-query');
  var footer = document.getElementById('ps-footer');
  var viewAll = document.getElementById('ps-view-all');

  var debounceTimer = null;
  var lastQuery = '';

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    if (q.length < 2) {
      ps.classList.remove('is-open');
      return;
    }
    if (q === lastQuery) return;
    debounceTimer = setTimeout(function () { search(q); }, 250);
  });

  function search(q) {
    lastQuery = q;
    ps.classList.add('is-open');
    if (loading) loading.hidden = false;
    if (results) results.innerHTML = '';
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = true;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product,collection,article,page'
            + '&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (data) {
        if (loading) loading.hidden = true;
        renderResults(data, q);
      })
      .catch(function () {
        if (loading) loading.hidden = true;
        if (empty) {
          queryEl && (queryEl.textContent = q);
          empty.hidden = false;
        }
      });
  }

  function renderResults(data, q) {
    if (!data.resources || !data.resources.results) {
      empty && (empty.hidden = false);
      return;
    }
    var r = data.resources.results;
    var anyResult = (r.products && r.products.length) || (r.collections && r.collections.length) ||
                    (r.articles && r.articles.length) || (r.pages && r.pages.length);

    if (!anyResult) {
      queryEl && (queryEl.textContent = q);
      empty && (empty.hidden = false);
      return;
    }

    var html = '';

    if (r.products && r.products.length) {
      html += '<div class="predictive-search__group-title">Products</div>';
      r.products.forEach(function (p) {
        var img = p.image || '';
        var price = p.price ? '$' + (parseFloat(p.price.replace(/[^\d.]/g, '')) || 0).toFixed(2) : '';
        html += ''
          + '<a href="' + p.url + '" class="ps-result">'
          + '  <div class="ps-result__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>'
          + '  <div class="ps-result__info">'
          + '    <span class="ps-result__title">' + p.title + '</span>'
          + (p.vendor ? '<span class="ps-result__meta">' + p.vendor + '</span>' : '')
          + '  </div>'
          + (price ? '<span class="ps-result__price">' + price + '</span>' : '')
          + '</a>';
      });
    }

    if (r.collections && r.collections.length) {
      html += '<div class="predictive-search__group-title">Collections</div>';
      r.collections.forEach(function (c) {
        html += '<a href="' + c.url + '" class="ps-result"><div class="ps-result__info"><span class="ps-result__title">' + c.title + '</span></div></a>';
      });
    }

    if (r.articles && r.articles.length) {
      html += '<div class="predictive-search__group-title">Articles</div>';
      r.articles.forEach(function (a) {
        html += '<a href="' + a.url + '" class="ps-result"><div class="ps-result__info"><span class="ps-result__title">' + a.title + '</span></div></a>';
      });
    }

    if (r.pages && r.pages.length) {
      html += '<div class="predictive-search__group-title">Pages</div>';
      r.pages.forEach(function (p) {
        html += '<a href="' + p.url + '" class="ps-result"><div class="ps-result__info"><span class="ps-result__title">' + p.title + '</span></div></a>';
      });
    }

    results.innerHTML = html;
    footer.hidden = false;
    if (viewAll) viewAll.href = '/search?q=' + encodeURIComponent(q);
  }
})();

/* ============================================
   PRODUCT VARIANT PICKER (color swatches + size buttons)
   ============================================ */
(function () {
  var variantsScript = document.querySelector('[id^="product-variants-"]');
  if (!variantsScript) return;
  var variants;
  try { variants = JSON.parse(variantsScript.textContent); }
  catch (e) { return; }

  var optionButtons = document.querySelectorAll('.opt-btn, .swatch-btn');
  if (optionButtons.length === 0) return;

  // Track current selections (by option position)
  var current = {};
  document.querySelectorAll('.prod-opt').forEach(function (opt) {
    var active = opt.querySelector('.is-active');
    if (active) {
      var pos = active.getAttribute('data-option-position');
      var val = active.getAttribute('data-value');
      if (pos && val) current[pos] = val;
    }
  });

  function findVariant() {
    return variants.find(function (v) {
      for (var i = 0; i < v.options.length; i++) {
        var pos = String(i + 1);
        if (current[pos] !== v.options[i]) return false;
      }
      return true;
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;

    // Update price display
    var priceEl = document.querySelector('.prod-info__price .price, .prod-info__price > span:first-child');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update ATC button
    var atcText = document.querySelector('[data-atc-text]');
    if (atcText) {
      atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    var atc = document.getElementById('add-to-cart');
    if (atc) {
      atc.disabled = !variant.available;
      // Set hidden variant ID input
      var idInput = document.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
    }

    // Update URL without reload
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    // Update selected-value display next to each option label
    document.querySelectorAll('.prod-opt').forEach(function (opt, idx) {
      var pos = String(idx + 1);
      var selectedEl = opt.querySelector('[data-selected-value]');
      if (selectedEl && current[pos]) selectedEl.textContent = current[pos];
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.getAttribute('data-option-position');
      var val = btn.getAttribute('data-value');
      if (!pos || !val) return;
      current[pos] = val;

      // Update active states within this option group
      var parent = btn.closest('.prod-opt');
      if (parent) {
        parent.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }
      updateUI();
    });
  });
})();

/* ============================================
   IMAGE ZOOM ON HOVER (product main image)
   ============================================ */
(function () {
  var main = document.getElementById('mainImage');
  if (!main) return;
  var img = main.querySelector('img');
  if (!img) return;

  // Only enable on desktop (mouse)
  if (window.matchMedia('(hover: none)').matches) return;

  var section = document.querySelector('[id^="shopify-section"] .prod-main, .prod-main');
  // Only run if [data-hover-zoom] is on the gallery wrapper
  var gallery = main.closest('.prod-gallery');
  if (!gallery || !gallery.hasAttribute('data-hover-zoom')) return;

  main.style.position = 'relative';
  main.style.overflow = 'hidden';

  main.addEventListener('mousemove', function (e) {
    var rect = main.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(1.8)';
  });
  main.addEventListener('mouseleave', function () {
    img.style.transform = '';
    img.style.transformOrigin = '';
  });
})();

/* ============================================
   QUICK ADD (delegated handler — uses data-product-handle)
   ============================================ */
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.prod-card');
    var handle = card ? card.getAttribute('data-product-handle') : null;
    var productUrl = btn.getAttribute('data-product-url');

    if (!handle && productUrl) {
      var m = productUrl.match(/\/products\/([^?\/]+)/);
      handle = m ? m[1] : null;
    }
    if (!handle) return;

    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('Product fetch failed');
      var product = await res.json();
      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (!variant) throw new Error('No variant');

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
      if (!addRes.ok) throw new Error('Add failed');

      // Update cart count badge
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      document.querySelectorAll('.cart-badge, .cart-count, #cart-item-count').forEach(function (b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? '' : 'none';
      });

      btn.textContent = '✓ Added';
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 1800);

      // Show toast
      var t = document.querySelector('.toast') || (function () {
        var d = document.createElement('div'); d.className = 'toast'; document.body.appendChild(d); return d;
      })();
      t.textContent = '✓ Added to cart';
      t.className = 'toast toast--success';
      setTimeout(function () { t.classList.add('show'); }, 10);
      setTimeout(function () { t.classList.remove('show'); }, 2400);

      // Open cart drawer if function exists
      if (typeof window.openCart === 'function') {
        setTimeout(function () { window.openCart(); }, 400);
      }
    } catch (err) {
      console.error('Quick add error:', err);
      btn.textContent = 'Try again';
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 1800);
    }
  });
})();

/* ============================================
   SELLING PLANS / SUBSCRIPTIONS
   ============================================ */
(function () {
  document.querySelectorAll('.selling-plan-vals .opt-btn').forEach(function (label) {
    label.addEventListener('click', function () {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      // Set checked on click (label click doesn't auto-fire if input is display:none)
      input.checked = true;
      // Update visual state
      var parent = label.closest('.selling-plan-vals');
      if (parent) {
        parent.querySelectorAll('.opt-btn').forEach(function (b) { b.classList.remove('is-active'); });
        label.classList.add('is-active');
      }
    });
  });
})();

/* ============================================
   VARIANT IMAGE SWAPPING (when variant changes, main image updates)
   ============================================ */
(function () {
  var variantsScript = document.querySelector('[id^="product-variants-"]');
  if (!variantsScript) return;
  var variants;
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

  function swapMainImageForVariant(variantId) {
    var variant = variants.find(function (v) { return v.id == variantId; });
    if (!variant || !variant.featured_image) return;
    var img = document.getElementById('prod-main-img');
    if (!img) return;
    // Build the high-res URL from the featured_image src
    var src = variant.featured_image.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_1200x.');
    if (src.indexOf('_1200x.') === -1) {
      src = variant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_1200x.$1');
    }
    img.src = src;
    if (variant.featured_image.alt) img.alt = variant.featured_image.alt;
  }

  // Listen for variant changes via the option buttons
  document.querySelectorAll('.opt-btn, .swatch-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTimeout(function () {
        var idInput = document.querySelector('input[name="id"]');
        if (idInput && idInput.value) swapMainImageForVariant(idInput.value);
      }, 30); // wait for variant picker to update id
    });
  });
})();
